/** Scope context passed into STEPS demo iframes (program + school details). */
export type PrismEmbedScope = {
  programName: string
  schoolName: string
  schoolLogo: string
  description: string
  programType: string
  degreeOffered: string
  addressLines: string[]
}

export const PRISM_EMBED_SCOPE_MESSAGE = "exxat-embed-scope" as const

export type PrismEmbedScopeMessage = {
  type: typeof PRISM_EMBED_SCOPE_MESSAGE
} & PrismEmbedScope

function encodeAddressLines(lines: string[]): string {
  return lines.join("|")
}

function decodeAddressLines(raw: string | null): string[] {
  if (!raw) return []
  return raw.split("|").filter(Boolean)
}

export function prismEmbedScopeQuery(scope: PrismEmbedScope): string {
  const params = new URLSearchParams()
  params.set("programName", scope.programName)
  params.set("schoolName", scope.schoolName)
  params.set("schoolLogo", scope.schoolLogo)
  params.set("description", scope.description)
  params.set("programType", scope.programType)
  params.set("degreeOffered", scope.degreeOffered)
  params.set("addressLines", encodeAddressLines(scope.addressLines))
  return params.toString()
}

export function postPrismEmbedScope(
  target: Window | null | undefined,
  scope: PrismEmbedScope,
): void {
  if (!target) return
  const message: PrismEmbedScopeMessage = {
    type: PRISM_EMBED_SCOPE_MESSAGE,
    ...scope,
  }
  target.postMessage(message, "*")
}

/** Parse scope from iframe URL search params. */
export function prismEmbedScopeFromSearchParams(
  params: URLSearchParams,
): PrismEmbedScope {
  return {
    programName: params.get("programName") ?? "",
    schoolName: params.get("schoolName") ?? "",
    schoolLogo: params.get("schoolLogo") ?? "",
    description: params.get("description") ?? "",
    programType: params.get("programType") ?? "",
    degreeOffered: params.get("degreeOffered") ?? "",
    addressLines: decodeAddressLines(params.get("addressLines")),
  }
}
